<template>
  <div>
    <div v-if="benutzerStatus.anmelden">
      <b-spinner variant="primary" type="grow"></b-spinner>
    </div>
    <div v-else>
      <b-form @submit.prevent="benutzerAnmelden" class="text-left">
        <b-form-group
          id="login-email-group"
          label="Anmeldename oder E-Mail"
          label-for="login-email"
        >
          <b-form-input
            id="login-email"
            v-model="benutzerDaten.email"
            type="text"
            aria-describedby="email-live-feedback"
            trim
            required
            autocomplete="on"
          ></b-form-input>

          <b-form-invalid-feedback id="email-live-feedback">
            Geben Sie eine gültige E-Mail ein.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          id="login-passwort-group"
          label="Passwort"
          label-for="login-passwort"
        >
          <b-input-group>
            <template #append>
              <b-button id="toggle-password" variant="outline-secondary" v-b-tooltip.hover title="Passwort ein- und ausblenden" @click="togglePassword"><font-awesome-icon icon="eye" /></b-button>
            </template>

            <b-form-input
              id="login-passwort"
              v-model="benutzerDaten.passwort"
              type="password"
              aria-describedby="passwort-live-feedback"
              trim
              required
              autocomplete="current-password"
            ></b-form-input>
          </b-input-group>

          <!-- <b-form-invalid-feedback id="passwort-live-feedback">
            Geben Sie ein gültiges Passwort ein.
          </b-form-invalid-feedback> -->
        </b-form-group>

        <!-- <div class="text-right mb-3">
          <span class="btn btn-link" v-b-modal.passwortVergessen>Passwort vergessen?</span>
        </div> -->

        <b-button id="loginButton" type="submit" variant="primary" class="float-right mb-3">Anmelden</b-button>
      </b-form>
    </div>

    <!-- <b-modal id="passwortVergessen" title="Passwort Vergessen" header-bg-variant="primary" header-text-variant="white" hide-footer>
      <div v-if="benutzerStatus.resettingPassword" class="text-center">
        <b-spinner variant="primary" type="grow" class="my-5"></b-spinner>
      </div>
      <div v-else-if="benutzerStatus.passwortReset">
        <b-alert variant="success" show>{{ benutzerStatus.passwortReset }}</b-alert>
        <b-button
              @click="$bvModal.hide('passwortVergessen')"
              variant="secondary"
              class="float-right"
            >Schließen</b-button>
      </div>
      <div v-else-if="benutzerStatus.errMsg">
        <b-alert variant="danger" class="my-5" show>{{ benutzerStatus.errMsg }}</b-alert>
        <b-button
          @click="$bvModal.hide('passwortVergessen')"
          variant="secondary"
          class="float-right"
        >Schließen</b-button>
      </div>
      <div v-else>
        <p>
          Bitte geben Sie die E-Mail-Adresse an, mit der sie bei <strong class="text-primary">Senio</strong> registriert sind. An diese Adresse schicken wir eine Mail, über die Sie Ihr Passwort zurücksetzen können.
        </p>
        <b-form @submit.prevent="passwortVergessen(passwortVergessenEmail)">
          <b-form-group
            id="passwort-vergessen-email-group"
            label="E-Mail Adresse"
            label-for="passwort-vergessen-email"
          >
            <b-form-input
              id="passwort-vergessen-email"
              v-model="passwortVergessenEmail"
              type="email"
              :state="emailState"
              aria-describedby="passwort-vergessen-email-live-feedback"
              trim
              required
            ></b-form-input>

            <b-form-invalid-feedback id="passwort-vergessen-email-live-feedback">
              Geben Sie eine gültige E-Mail ein.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-button
            @click="$bvModal.hide('passwortVergessen')"
            variant="secondary"
          >Abbrechen</b-button>

          <b-button id="passwortVergessenButton" type="submit" variant="primary" class="float-right mb-3">Passwort zurücksetzen</b-button>
        </b-form>
      </div>
    </b-modal> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Anmelden',
  computed: {
    ...mapGetters(['benutzerStatus']),
    emailState () {
      const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
      
      if (this.benutzerDaten.email === '') {
        return null
      }

      return emailRegex.test(this.benutzerDaten.email)
    },
    passwortState () {
      if (this.benutzerDaten.passwort === '') {
        return null
      }

      return this.benutzerDaten.passwort.length > 2 ? true : false
    }
  },
  methods: {
    ...mapActions(['anmelden', 'getBenutzerBild', 'passwortVergessen']),
    benutzerAnmelden () {
      this.anmelden(this.benutzerDaten, this.rememberMe)
        .then(() => {
          if (!this.benutzerStatus.errMsg) {
            this.getBenutzerBild()
          }

          if (this.benutzerStatus.errMsg) {
            this.$bvToast.toast(this.benutzerStatus.errMsg, {
              title: `Es ist etwas schief gelaufen.`,
              toaster: 'b-toaster-top-full',
              variant: 'danger',
              autoHideDelay: 7000,
              appendToast: true,
              solid: true
            })
          }
        })
    },
    togglePassword () {
      var passInput = document.getElementById('login-passwort')
      var btn = document.getElementById('toggle-password')

      if (passInput.type == 'password') {
        passInput.type = 'text'
        btn.classList.remove('btn-outline-secondary')
        btn.classList.add('btn-secondary')
      }
      else {
        passInput.type = 'password'
        btn.classList.remove('btn-secondary')
        btn.classList.add('btn-outline-secondary')
      }
    }
  },
  data () {
    return {
      benutzerDaten: {
        email: '',
        passwort: ''
      },
      emailVal: false,
      passwordVal: false,
      passwortVergessenEmail: ''
    }
  }
}
</script>
